import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { StsAdminService } from '../sts-admin.service';

@Component({
  selector: 'app-sts-order-export',
  templateUrl: './sts-order-export.component.html',
  styleUrls: ['./sts-order-export.component.scss'],
})
export class StsOrderExportComponent implements OnInit, OnDestroy {
  seasonList: any;
  fileExportForm = this.fb.group({
    seasoncode: [null, [Validators.required]],
  });
  seasonSub: Subscription;
  constructor(
    private readonly fb: FormBuilder,
    private readonly stsAdminService: StsAdminService,
    private readonly cd: ChangeDetectorRef,
    private readonly globalMessage: GlobalMessageService
  ) {}

  ngOnInit(): void {
    this.stsAdminService.getSeasonalList().subscribe((res) => {
      if (res?.categoryData) {
        this.seasonList = res?.categoryData;
      }
    });
  }
  ngOnDestroy(): void {
    this.seasonSub?.unsubscribe();
  }
  exportExcel() {
    let params = { seasonCode: this.fileExportForm.get('seasoncode').value };
    this.stsAdminService.orderExportExcel(params).subscribe((res) => {
      this.globalMessage.add(
        res.status,
        GlobalMessageType.MSG_TYPE_CONFIRMATION,
        10000
      );
    });
  }
}
